<template>
  <div>
    <el-empty description="404 页面找不到">
      <el-button size="small" @click="onBackClick">返回上一页</el-button>
      <el-button size="small" @click="onHomeClick" type="primary">
        跳转到首页
      </el-button>
    </el-empty>
  </div>
</template>

<script>
export default {

  methods: {
    onHomeClick() {
      this.openRoutePage('/')
    },
    onBackClick() {
      if (this.$router) {
        this.$router.back();
      }
      if (this.$drawer) {
        this.$drawer.backDrawer();
      }
    }
  }
};
</script>
